// extracted by mini-css-extract-plugin
export default {"header":"ContinentHeader_header__lzXO3","image":"ContinentHeader_image__gkFp9","breaker":"ContinentHeader_breaker__HC1jA"};